import * as __WEBPACK_EXTERNAL_MODULE__emotion_react_jsx_runtime_fc4df778__ from "@emotion/react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE__dion_web_env_service_a213eb18__ from "@dion-web/env-service";
import * as __WEBPACK_EXTERNAL_MODULE__dion_web_http_c8f3a803__ from "@dion-web/http";
import * as __WEBPACK_EXTERNAL_MODULE__dion_web_cookie_ecda4a6e__ from "@dion-web/cookie";
const DionWebContainerBrowserAppLazy = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].lazy(()=>import("../DionWebContainerBrowserApp/index.mjs"));
new __WEBPACK_EXTERNAL_MODULE__dion_web_http_c8f3a803__.DionHostHTTPTransport({
    getAuthUrl: ()=>__WEBPACK_EXTERNAL_MODULE__dion_web_env_service_a213eb18__.dionWebEnvService.get('DION_PLATFORM_GATEWAY_API_HOST') + '/platform/v1',
    getBaseUrl: ()=>__WEBPACK_EXTERNAL_MODULE__dion_web_env_service_a213eb18__.dionWebEnvService.get('DION_PLATFORM_GATEWAY_API_HOST'),
    expiredTokenCallback: ()=>{
        window.location.replace(__WEBPACK_EXTERNAL_MODULE__dion_web_env_service_a213eb18__.dionWebEnvService.get('DION_PLATFORM_WEB_HOST'));
    },
    refreshTokenCallback: (token)=>{
        __WEBPACK_EXTERNAL_MODULE__dion_web_cookie_ecda4a6e__.dionCookieService.set('vc-access-token', token);
    }
});
const DionWebContainerApp = (props)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE__emotion_react_jsx_runtime_fc4df778__.jsx)(__WEBPACK_EXTERNAL_MODULE__dion_web_env_service_a213eb18__.DionEnvServiceWrapper, {
        lazyChildrenProps: props,
        lazyChildren: DionWebContainerBrowserAppLazy,
        url: '/platform/envs.json'
    });
export { DionWebContainerApp };

//# sourceMappingURL=DionWebContainerApp.mjs.map